<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" app>
      <v-list dense>
        <v-list-item link>
          <v-list-item-action>
            <v-icon>mdi-home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link>
          <v-list-item-action>
            <v-icon>mdi-contact-mail</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Contact</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="indigo" dark>
      <!--<v-app-bar-nav-icon @click.stop="drawer = !drawer" />-->
      <v-icon>create</v-icon>

      <v-toolbar-title id="app-title">
        Draw Every Day
      </v-toolbar-title>
    </v-app-bar>

    <v-content>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col class="text-center">
            <div class="">{{ currentTagline }} {{ currentItem }}</div>
          </v-col>
        </v-row>

        <v-row align="center" justify="center">
          <v-col class="text-center">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn @click="randomItem" icon large target="_blank" v-on="on">
                  <v-icon large>autorenew</v-icon>
                </v-btn>
              </template>
              <span>New topic</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
    <v-footer color="indigo" app>
      <span class="white--text">&copy; Sharon &amp; Pieter-Jan</span>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: "App",
  props: {
    source: String
  },
  methods: {
    randomItem() {
      //call API
      //Setup game
      let appendix = "";
      let newItemId = Math.floor(Math.random() * this.items.length);
      while (this.currentItemId == newItemId) {
        newItemId = Math.floor(Math.random() * this.items.length);
      }
      this.currentItemId = newItemId;
      this.currentItem = this.items[newItemId];

      if (
        this.currentItem[0] == "a" ||
        this.currentItem[0] == "e" ||
        this.currentItem[0] == "i" ||
        this.currentItem[0] == "o" ||
        this.currentItem[0] == "u"
      ) {
        appendix = "n";
      }

      let taglineId = Math.floor(Math.random() * this.taglines.length);
      this.currentTagline = this.taglines[taglineId] + appendix;
    }
  },
  mounted() {
    this.randomItem();
  },
  /*methods: {
    randomItem: () => {
      let newItemId = Math.floor(Math.random() * this.items.length);
      while (this.currentItemId == newItemId) {
        newItemId = Math.floor(Math.random() * this.items.length);
      }
      this.currentItemId = newItemId;
      this.currentItem = this.items[newItemId];
    }
  },
  mounted: () => {
    this.randomItem();
  },*/
  data: () => ({
    currentItem: null,
    currentItemId: null,
    drawer: false,
    currentTagline: null,
    taglines: [
      "Why don't you draw a",
      "Let's see your take on a",
      "Maybe something that resembles a",
      "What do you make of a"
    ],
    items: [
      "apple",
      "bag",
      "balloon",
      "banana",
      "bed",
      "beef",
      "blouse",
      "book",
      "bookmark",
      "boom box",
      "bottle",
      "bottle cap",
      "bow",
      "bowl",
      "box",
      "bracelet",
      "bread",
      "brocolli",
      "hair brush",
      "buckel",
      "button",
      "camera",
      "candle",
      "candy wrapper",
      "canvas",
      "car",
      "greeting card",
      "playing card",
      "carrot",
      "cat",
      "CD",
      "cell phone",
      "packing peanut",
      "cinder block",
      "chair",
      "chalk",
      "newspaper",
      "soy sauce packet",
      "chapter book",
      "checkbook",
      "chocolate",
      "clay pot",
      "clock",
      "clothes",
      "computer",
      "conditioner",
      "cookie jar",
      "cork",
      "couch",
      "credit card",
      "cup",
      "deodorant",
      "desk",
      "door",
      "drawer",
      "drill press",
      "eraser",
      "eye liner",
      "face wash",
      "fake flower",
      "flag",
      "floor",
      "flower",
      "food",
      "fork",
      "fridge",
      "glass",
      "glow stick",
      "grid paper",
      "hair tie",
      "hanger",
      "helmet",
      "house",
      "ipod",
      "charger",
      "key chain",
      "keyboard",
      "keys",
      "knife",
      "lace",
      "lamp",
      "lamp shade",
      "leg warmer",
      "lip gloss",
      "lotion",
      "milk",
      "mirror",
      "model car",
      "money",
      "monitor",
      "mop",
      "mouse pad",
      "mp3 player",
      "nail clipper",
      "nail file",
      "needle",
      "outlet",
      "paint brush",
      "pants",
      "paper",
      "pen",
      "pencil",
      "perfume",
      "phone",
      "photo album",
      "picture frame",
      "pillow",
      "plastic fork",
      "plate",
      "pool stick",
      "soda can",
      "puddle",
      "purse",
      "blanket",
      "radio",
      "remote",
      "ring",
      "rubber band",
      "rubber duck",
      "rug",
      "rusty nail",
      "sailboat",
      "sand paper",
      "sandal",
      "scotch tape",
      "screw",
      "seat belt",
      "shampoo",
      "sharpie",
      "shawl",
      "shirt",
      "shoe lace",
      "shoes",
      "shovel",
      "sidewalk",
      "sketch pad",
      "slipper",
      "soap",
      "socks",
      "sofa",
      "speaker",
      "sponge",
      "spoon",
      "spring",
      "sticky note",
      "stocking",
      "stop sign",
      "street light",
      "table",
      "teddies",
      "television",
      "thermometer",
      "thread",
      "tire swing",
      "tissue box",
      "toe ring",
      "toilet",
      "tomato",
      "tooth pick",
      "toothbrush",
      "toothpaste",
      "towel",
      "tree",
      "truck",
      "tv",
      "twister",
      "vase",
      "video game",
      "wallet",
      "washing machine",
      "watch",
      "water bottle",
      "doll",
      "magnet",
      "wagon",
      "headphone",
      "clamp",
      "USB drive",
      "air freshener",
      "piano",
      "ice cube tray",
      "white out",
      "window",
      "controller",
      "coasters",
      "thermostat",
      "zipper"
    ]
  })
};
</script>

<style scoped>
#app-title {
  margin-left: 15px;
}
.subject {
  text-transform: capitalize;
}
.container.fill-height {
  align-items: center;
  justify-content: center;
}
</style>
